import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom'
import './Menu.scss';

import { NavLink } from 'react-router-dom'
import { Fire } from '../../services'

import { ASSO_TYPE, PLACE_TYPE, ADS_MAKER_TYPE } from '../../types/types'
import ProValidator from '../Admin/Pros/ProValidator'

interface Props {
  location: any;
}
const Menu: React.FC<Props> = (props) => {
  
  const user = useSelector(state => state.authReducer.user)
  const isHome = props.location.pathname === "/"
  const history = useHistory()

  const logout = () => {
    const confirm = window.confirm('Souhaitez-vous vraiment vous déconnecter ?')
    if (!confirm)
      return;
    Fire.auth().signOut()
    localStorage.clear()
    history.push('/')
  }
  const help = () => {
    window.open('mailto:assistance@popoutparis.com')
    //window.open('https://www.facebook.com/PopOutParis/', '_blank');
  }

  const cgu_link = 'https://firebasestorage.googleapis.com/v0/b/popout-c514d.appspot.com/o/A-LEGAL-INFO%2FCGV_Pop_Out.pdf?alt=media&token=20ba6c58-7f5b-4509-9334-f26e89b76b0e'
  const privacy_link = 'https://firebasestorage.googleapis.com/v0/b/popout-c514d.appspot.com/o/A-LEGAL-INFO%2FCharte_vie_prive%CC%81e_Pop_Out.pdf?alt=media&token=dbdbe0cb-71f0-457b-9ff3-e396cc4df49c'
  const account_valid = ProValidator.isAccountValid(user)

  const renderProMenu = () => {
    switch (user.type || '') {
      case ASSO_TYPE:
        return (
          <React.Fragment>
            <li className="nav-item">
              <NavLink to="/parrainage" className="nav-link" activeClassName="active">
                <i className="nav-icon fa fa-user-friends"></i>
                <p>
                  Parrainage
                </p>
              </NavLink>
            </li>
          </React.Fragment>
        )
        break;

      default:
        break;
    }
    return (null)
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <div className="sidebar">

        <NavLink to={!user.admin ? "/settings" : "/"} className="nav-link" style={{padding: 0}}>
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              {user.pictures && user.pictures.length ? (
                <img src={user.pictures[0]} className="img-circle elevation-2" alt="User" />
              ) : (
                <img src={require('../../images/logo.png')} className="img-circle elevation-2" alt="User" />
              )}
            </div>
            <div className="info">
              <span className="d-block" style={{color: '#fff'}}>{user.admin ? 'Administrateur' : (user.name || 'Votre compte')}</span>
            </div>
          </div>
        </NavLink>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            { !user.admin ? (
              <React.Fragment>
              
                <li className="nav-header">Votre activité</li>
                
                <li className="nav-item">
                  <NavLink to="/settings" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-user"></i>
                    <p>
                      Votre compte
                      { account_valid ? (
                        <span className="badge-success right menu-status"></span>
                      ) : user.stripe_link ? (
                        <span className="badge-warning right menu-status"></span>
                      ) : (
                        <span className="badge-danger right menu-status"></span>
                      )}
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/app" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-calendar-alt"></i>
                    <p>
                      Vos annonces
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/scan" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-ticket"></i>
                    <p>
                      Scan de ticket
                    </p>
                  </NavLink>
                </li>

                { renderProMenu() }

                { user.type === ASSO_TYPE &&
                  <li className="nav-item">
                    <NavLink to="/partners" className="nav-link" activeClassName="active">
                      <i className="nav-icon fa fa-handshake" style={{fontSize: 15}}></i>
                      <p>
                        Annuaire
                      </p>
                    </NavLink>
                  </li>
                }

                <li className="nav-item">
                  <NavLink to="/payouts" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-dollar"></i>
                    <p>
                      Virements
                    </p>
                  </NavLink>
                </li>
                
              </React.Fragment>
            ) : (
              <React.Fragment>
                <li className="nav-header">Admin</li>
                
                <li className="nav-item">
                  <NavLink to="/app" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-tag"></i>
                    <p>
                      Annonces
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/pros" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-users" style={{fontSize: 15}}></i>
                    <p>
                      Professionels
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/payouts" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-dollar"></i>
                    <p>
                      Virements
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/map" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-map" style={{fontSize: 15}}></i>
                    <p>
                      Map
                    </p>
                  </NavLink>
                </li>


                <li className="nav-item">
                  <NavLink to="/admin/partners" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-handshake" style={{fontSize: 15}}></i>
                    <p>
                      Annuaire
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/notifs" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-bullhorn" style={{fontSize: 15}}></i>
                    <p>
                      Notifications
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/games" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-trophy"></i>
                    <p>
                      Jeux concours
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/scan" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-ticket"></i>
                    <p>
                      Scan de ticket
                    </p>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to="/admin/test/accounts" className="nav-link" activeClassName="active">
                    <i className="nav-icon fa fa-user-shield"></i>
                    <p>
                      Comptes de tests
                    </p>
                  </NavLink>
                </li>

                { user.role === 'super_admin' &&
                  <li className="nav-item">
                    <NavLink to="/admin/admins" className="nav-link" activeClassName="active">
                      <i className="nav-icon fa fa-user-lock"></i>
                      <p>
                        Administrateurs
                      </p>
                    </NavLink>
                  </li>
                }

                { user.role === 'super_admin' &&
                  <li className="nav-item">
                    <NavLink to="/admin/stats" className="nav-link" activeClassName="active">
                      <i className="nav-icon fa fa-tachometer-alt"></i>
                      <p>
                        Statistiques
                      </p>
                    </NavLink>
                  </li>
                }
              </React.Fragment>
            )}

            <li className="nav-header">Assistance</li>
            <li className="nav-item">
              <span className="nav-link nav-link-custom" onClick={help}>
               <i className="nav-icon fa fa-question-circle" style={{fontSize: 17}}></i>
                <p>
                  Besoin d'aide ?
                </p>
              </span>
            </li>
            <li className="nav-item">
              <span className="nav-link nav-link-custom" onClick={logout}>
                <i className="nav-icon fa fa-sign-out-alt"></i>
                <p>
                  Déconnexion
                </p>
              </span>
            </li>
            <li className="nav-item" style={{textAlign: 'center', fontSize: 12, marginTop: 10}}>
              <a href={cgu_link} target='_blank'>CGU / CGV</a>
            </li>
            <li className="nav-item" style={{textAlign: 'center', fontSize: 12, marginTop: 10}}>
              <a href={privacy_link} target='_blank'>Confidentialité</a>
            </li>


          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default withRouter(Menu)